
<mat-form-field class="sebastian-input" floatLabel="never">
  <input matInput [placeholder]="placeholder" [matAutocomplete]="auto" [formControl]="userCtrl">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
      <span>{{user.name}}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
